import { PROMO_BANNER as PROPERTY_PROMO_BANNER } from '@/constants/property.js'

export const PROMO_BANNER = {
  co_living: {
    title: 'Say goodbye to traditional security deposits**',
    description: `Moving expenses can add up quickly. That's why Bungalow offers zero or reduced security deposits for qualified applicants, keeping more money in your pocket.<br>**For qualified applicants only`,
  },
  group_living: PROPERTY_PROMO_BANNER.group_living,
}
